import { Box, Grid2, Paper, Typography } from "@mui/material";
import React from "react";
// import aboutUsBg from "../../../Images/aboutUsBg.jpg";
import { commonCss } from "../../../CssStyle/commonCss";
import Custom from "../Service/Custom";
import coaching from "../../../Images/HRDF/coaching.json";
import mentoring from "../../../Images/HRDF/mentoring.json";
import training from "../../../Images/HRDF/training.json";
const HDRF = () => {
  const coachingList = [
    "Life",
    "Career",
    "Mind, Heart and Soul",
    "Women",
    "Individual Coaching",
  ];
  const mentoringList = ["Type: Specialized", "Frequency: Twice monthly"];
  const trainingList = [
    "Excellence in Leadership & Management",
    "Developing Authentic Leadership",
    "Empowered to Rise: Women in Leadership",
    "Developing a Growth Mindset and Emotional Intelligence for Organizational Success",
    "Essentials of Project Management – Navigating Frameworks and Execution",
    "Driving Meaningful Customer Excellence: Revolutionizing Service and Optimizing Outcomes",
    "Customized In-House Training Programs for Corporate Success",
  ];
  return (
    <Grid2 container>
      <Grid2
      size={12}
        container
        justifyContent={"center"}
        sx={{
          padding: { xs: "1rem", md: "3rem 2rem" },

          background: `url(/Images/aboutUsBg.jpg)`,
          backgroundSize: "cover",
        }}
      >
        <Box
          sx={{
            // width: "100%",
            // mt: { xs: "35%", sm: "25%", md: "15%", lg: "16%", xl: "5%" },
            mt:"15vh",
            maxWidth: { xs: "auto", xl: "2000px" },
            display: "flex",
            justifyContent: "center",

            // pl: { xs: 0, md:"2rem",lg: "10rem" },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: { xs: "100%", md: "85%" },

              gap: "2rem",
            }}
          >
            <Typography
              sx={{
                textAlign: "center",
                //  mt: "2%",
                fontSize: { xs: "1.5rem", md: "2rem", lg: "3.3rem" },
                width: "100%",
                fontWeight: 600,
                pl: { xs: "1rem", md: "2rem" },
                //   borderLeft: `7px solid ${commonCss.orange}`,
              }}
            >
              HRDF Training
            </Typography>
            <Typography
              sx={{
                fontSize: "1.1rem",
                pl: "0.5rem",
                width: "100%",
                textAlign: "center",
              }}
            >
              We transform potential into performance through end-to-end
              capability building. Combining training, coaching, and mentoring,
              we elevate skills from foundational knowledge to expert mastery.
            </Typography>
          </Box>
        </Box>
      </Grid2>
      <Custom
        spacing={{ xs: "1rem", md: "1rem" }}
        displayDesc={true}
        direction={"row"}
        lottieImage={coaching}
        title={"Coaching"}
        subtitle={
          "We help you tap into your true potential, building strategies that lead to remarkable outcomes and a meaningful life."
        }
        description={
          "Our programs help you reflect on all aspects of your life and take intentional steps toward your future."
        }
        //   listTitle={"Our customized Custom Solutions :"}
        listName={coachingList}
        width={"90%"}
        id="coaching"
        styleSX={{
          background: `white`,
          backgroundSize: "cover",
          padding: { xs: "1.5rem", md: "3rem" },
        }}
        //   mt={{xs:"40%",sm:"30%",md:"15%",lg:"13%",xl:"5%"}}
        mt={0}
      />
      <Custom
        spacing={{ xs: "5rem", md: "6rem" }}
        displayDesc={true}
        direction={"row-reverse"}
        lottieImage={mentoring}
        title={"Mentoring"}
        subtitle={
          "We empower growth at every level—personal, professional, and organizational—by turning experience into impactful insights."
        }
        description={
          "Book a personal discovery call to see if mentoring aligns with your growth journey."
        }
        listName={mentoringList}
        width={"90%"}
        id="mentoring"
        mt={0}
        styleSX={{
          background: commonCss.backgroundGray,
          padding: { xs: "1.5rem", md: "3rem" },
        }}
      />
      <Custom
        spacing={{ xs: "1rem", md: "1rem" }}
        direction={"row"}
        lottieImage={training}
        title={"Training"}
        subtitle={
          "Advancing individual and team performance through strategic skill development tailored to your objectives."
        }
        //   listTitle={"Our customized Custom Solutions :"}
        listName={trainingList}
        width={"90%"}
        id="coaching"
        styleSX={{
          background: `white`,
          backgroundSize: "cover",
          padding: { xs: "1.5rem", md: "3rem" },
        }}
        //   mt={{xs:"40%",sm:"30%",md:"15%",lg:"13%",xl:"5%"}}
        mt={0}
      />
    </Grid2>
  );
};

export default HDRF;
